
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/th",
      function () {
        return require("private-next-pages/th/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/th"])
      });
    }
  